import { SecuritySchemes } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class DeliveryDetails<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Get info related with delivery details of an specific order.
	 *
	 * @tags Delivery Details
	 * @name DeliveryDetails
	 * @summary Get Delivery Details by OrderId
	 * @request GET:/store/{storeId}/hdm/order/{orderId}/deliveryDetails
	 * @response `200` `SecuritySchemes` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	deliveryDetails = (
		storeId: string,
		orderId: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
			/** Define if is checkout page: true/false */
			checkoutPage?: boolean;
			/** Define if is confirmation page: true/false */
			confirmationPage?: boolean;
			/** Define if is order details page: true/false */
			orderDetailsPage?: boolean;
			/** Define if sort data in thank you page */
			typSort?: boolean;
			/** Define the itemDeliveryType of the order */
			itemDeliveryType?: 'Fleet' | 'Parcel';
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['deliveryDetails'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/order/${orderId}/deliveryDetails`,
				params: _params,
				query: query,
				methodName: 'deliveryDetails',
			};
			logger.trace(traceData);
		}
		return this.http.request<SecuritySchemes, void>({
			path: `/store/${storeId}/hdm/order/${orderId}/deliveryDetails`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
